import Filter from "./features/Filter";
import List from "./features/List";
import {useEffect, useState} from "react";
import {AnalyzeSearchParamType} from "./interface";
import {analyzeListMapInit, analyzeSearchParamInit} from "./state";
import {useReadInventoryAnalysis} from "./hooks/useReadInventoryAnalysis";
import moment from "moment/moment";

export default function AnalyzeList() {
    // const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const [searchParam, setSearchParam] = useState<AnalyzeSearchParamType>((() => ({
        ...analyzeSearchParamInit,
        endAt: moment().format("YYYY-MM-DD"),
        startAt: moment().startOf('year').format("YYYY-MM-DD"),
    }))())

    const {data: analyze} = useReadInventoryAnalysis({param: searchParam});

    /*
    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);
    */

    useEffect(() => {
        setSearchParam({...searchParam})
    }, []);

    return <>
        <Filter searchParam={searchParam}
                setSearchParam={setSearchParam}/>

        <List analyze={analyze ?? analyzeListMapInit}
              searchParam={searchParam}/>
    </>
}